import { http, notify } from 'utils'
import { set, findIndex } from 'lodash'
import { checkEmail } from 'utils/errorHelpers'

// Staff user mutation imports.
import {
  SET_MANAGER_STAFF_USERS,
  SET_MANAGER_STAFF_USER,
  ADD_MANAGER_STAFF_USER,
  SET_MANAGER_STAFF_USER_PROPERTY,
  REPLACE_MANAGER_STAFF_USER,
  SET_CLUB_EMAIL
} from 'vx/mutations'

// Staff user state.
const initialStaffUserState = () => ({
  first_name: null,
  last_name: null,
  email: null,
  phone: null
})

const state = {
  staffUsers: [],
  staffUser: initialStaffUserState(),
  clubEmail: null
}

// Staff user state getters.
const getters = {}

// Staff user actions.
const actions = {
  getManagerStaffUsers ({ commit }, { id, params = {} }) {
    return http.get(`users/${id}/manager_staff_users`, { params }).then(response => {
      commit(SET_MANAGER_STAFF_USERS, response.data)
    })
  },

  storeManagerStaffUser ({ commit }, { id, payload }) {
    return http
      .post(`users/${id}/manager_staff_users`, payload)
      .then(response => {
        commit(ADD_MANAGER_STAFF_USER, response.data)
      })
      .catch(error => {
        if (checkEmail(error)) {
          notify.error('That email has already been taken.')
          throw error
        } else {
          notify.error('Something went wrong. Please check your input and try again.')
        }
      })
  },

  getClubEmail ({ commit }, { id, params = {} }) {
    return http.get(`users/${id}/manager_staff_users`, { params }).then(response => {
      commit(SET_MANAGER_STAFF_USERS, response.data)
    })
  },

  storeClubEmail ({ commit }, { id, payload }) {
    return http
      .post(`users/${id}/manager_staff_users`, payload)
      .then(response => {
        commit(ADD_MANAGER_STAFF_USER, response.data)
      })
  },

  resetClubEmail ({ commit }) {
    commit(SET_CLUB_EMAIL, [])
  },

  resetManagerStaffUsers ({ commit }) {
    commit(SET_MANAGER_STAFF_USERS, [])
  },

  resetManagerStaffUser ({ commit }) {
    commit(SET_MANAGER_STAFF_USER, initialStaffUserState())
  },

  activateManagerStaffUser ({ commit }, id) {
    return http
      .put(`users/${id}/activate`)
      .then((response) => {
        commit(REPLACE_MANAGER_STAFF_USER, { id, staffUser: response.data })
      })
  },

  deactivateManagerStaffUser ({ commit }, id) {
    return http
      .put(`users/${id}/deactivate`)
      .then((response) => {
        commit(REPLACE_MANAGER_STAFF_USER, { id, staffUser: response.data })
      })
  },

  setManagerStaffUserProperty ({ commit }, { property, value }) {
    commit(SET_MANAGER_STAFF_USER_PROPERTY, { property, value })
  }
}

// Staff user state mutations.
const mutations = {
  [SET_MANAGER_STAFF_USERS] (state, staffUsers) {
    state.staffUsers = staffUsers
  },

  [SET_MANAGER_STAFF_USER] (state, staffUser) {
    state.staffUser = staffUser
  },

  [SET_CLUB_EMAIL] (state, clubEmail) {
    state.clubEmail = clubEmail
  },

  [ADD_MANAGER_STAFF_USER] (state, staffUser) {
    state.staffUsers.unshift(staffUser)
  },

  [REPLACE_MANAGER_STAFF_USER] (state, { id, staffUser }) {
    let index = findIndex(state.staffUsers, existing => existing.id === id)

    if (index !== undefined) {
      state.staffUsers.splice(index, 1, staffUser)
    }
  },

  [SET_MANAGER_STAFF_USER_PROPERTY] (state, { property, value }) {
    set(state.staffUser, property, value)
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
